"use strict";

import ReactDOM from 'react-dom';
import React from 'react';


import { IconGlyphicon, IconFontAwesome } from 'generics/icons';
import {  SourceListener  } from 'generics/dataBound';
import {  objectMap, classMixer,  mkHashMap  }  from  'generics/utils';
import { BootButton, CloseButton } from 'generics/buttons';
import { _I_, defineSimpleTerm } from 'components/locs';

import ApplicationEvents from 'components/applicationEvents';
import  {
    isExpired,  fetchExtendedTags, cmpClassInfoTagValue,  cmpClassInfoTagCategory,
  } from 'components/classInfoUtil';
import {
    ViewAppIdIcon,
    ViewItemIconic,
    ViewAmountBadge,
    ViewItemDetailed
  } from 'components/commonAssets';
import {  PagerControl  } from 'components/generics';
import {  ViewInventoryTextFilter  } from 'components/inventoryTextFilter';
import {
    refreshBlockedPairs,  blockedPairsSource,  blockedPairsKey,
    getBlockedPairAffectAfter,  isPairBlocked,
  } from 'api/rpcAPICall';


import ViewQuickSellDialog from 'components/quickSellDialog';
import {IconImage} from "../generics/icons";


// LogStream.enable( "VIEWUSERINVENTORY" );

class VITCValue  {
  // { category, internal_name, category_name, name, color?, amount, classes, active  }
  constructor( tagDesc )  {
    this.category = tagDesc.category;
    this.category_name = tagDesc.category_name;

    this.internal_name = tagDesc.internal_name;
    this.name = tagDesc.name;
    this.color = tagDesc.color;

    this.amount = 0;
    this.classes = 0;
    this.active = false;
  }
}


class VITCCategory  {
  constructor( tagDesc )  {
    this.category = tagDesc.category;
    this.category_name = tagDesc.category_name;
    this.values = {}
  }


  getValue( tagDesc )  {
    if ( !(tagDesc.internal_name in this.values) )
      this.values[tagDesc.internal_name] = new VITCValue( tagDesc );
    return this.values[tagDesc.internal_name];
  }


  isActive()  {
    for( let valueName in this.values )  {
      if ( this.values[valueName].active )
        return true;
    }
    return false;
  }


  getSorted()  {
    let values = Object.values(this.values);
    values.sort( cmpClassInfoTagValue );
    return values;
  }

}


class VITCHolder  {
  constructor()  {
    this.cats = {}
  }


  getValue( tagDesc )  {
    if ( !(tagDesc.category in this.cats) )
      this.cats[tagDesc.category] = new VITCCategory( tagDesc );
    return this.cats[tagDesc.category].getValue( tagDesc );
  }


  isActive()  {
    for( let category in this.cats )  {
      if ( this.cats[category].isActive() )
        return true;
    }
    return false;
  }


  getSorted()  {
    let cats = Object.values(this.cats);
    cats.sort( cmpClassInfoTagCategory );
    return cats;
  }
}


class ViewInventoryTagCloud extends React.Component  {
  constructor(props)  {
    super(props);

    // { category, internal_name, category_name, name, color?, amount, classes, active  }
    this.state = {
      tagCloud: new VITCHolder()
    };
  }


  componentDidMount()  {
    this.setupTagCloudState();
  }


  componentWillUnmount()  {
    this.props.onChangeFilter && this.props.onChangeFilter( () =>  true );
  }


  componentWillReceiveProps(nextProps)  {
    if ( this.props.gameContexts !== nextProps.gameContexts )
      this.setupTagCloudState();
  }


  setupTagCloudState()  {
    this.setState( (prevState, props) =>  {
        const tagCloud = this.agregateTagCloud( prevState, props );
        props.onChangeFilter && props.onChangeFilter( this.getFilter( tagCloud ) );
        return { tagCloud };
      });
  }


  getFilter( holder )  {
    let conditions = [];
    holder.getSorted().map( ( category ) =>  {
      let valueList = [];
      category.getSorted().map( ( value ) =>  {
        if ( value.active )  {
          valueList.push( value.internal_name );
        }
      });
      if ( valueList.length )
        conditions.push( { "category":category.category, "internal_name":valueList })
    });

    LogStream("VIEWUSERINVENTORY").info( "getFilter ======== ", conditions );

    return ( item ) =>  {
        if ( conditions.length == 0 )
          return true;

        const tags = fetchExtendedTags( item.classInfo );
        if ( tags.length == 0 )
          return false;

        let allowed = true;
        // every category condition must be met
        conditions.map( ( cond ) =>  {
          let conditionMet = false;
          tags.map( (tt) =>  {
            if ( tt.category == cond.category )  {
              cond.internal_name.map( ( iname ) =>  {
                if ( tt.internal_name == iname )  {
                  conditionMet = true;
                }
              });
            }
          });

          if ( !conditionMet )
            allowed = false;
        });

        return allowed;
      };
  }


  toggleTag( tagValue )  {
    this.setState( (prevState, props) =>  {

        // clone
        let ret = new VITCHolder();
        prevState.tagCloud.getSorted().map( ( category ) =>  {
          category.getSorted().map( ( value ) =>  {
            let newValue = ret.getValue( value );
            newValue.amount = value.amount;
            newValue.classes = value.classes;
            newValue.active = value.active;
          });
        });

        // switch
        let tgt = ret.getValue(tagValue);
        tgt.active = !tgt.active;
        props.onChangeFilter && props.onChangeFilter( this.getFilter( ret ) );
        return {"tagCloud": ret}
      });


  }


  collectContextTags( holder, items )  {
    items.map( (item)=>  {
      const tags = fetchExtendedTags( item.classInfo );
      tags.map( (tagDesc)=>  {
        if ( !tagDesc.name )
          return;
        let tagValue = holder.getValue(tagDesc);
        tagValue.amount += item.totalAmount;
        tagValue.classes++;
      });
    });
  }


  copyActiveState( holder, prevHolder )  {
    holder.getSorted().map( ( category ) =>  {
      category.getSorted().map( ( value ) =>  {
        if ( prevHolder.getValue( value ).active )
          value.active = true;
      });
    });
  }


  agregateTagCloud( prevState, props )  {
    let tagCloud = new VITCHolder();

    objectMap( props.gameContexts, ( ctx, key ) => {
        const items = Object.values(ctx.stackedContents || {});
        this.collectContextTags( tagCloud, items )
      });

    this.copyActiveState( tagCloud, prevState.tagCloud );

    return tagCloud;
  }


  renderTagValue( tagValue )  {
    const checkedClassName = classMixer("view-inventory-tag-entry-check", "glyphicon",
                                        tagValue.active ? "glyphicon-check" : "glyphicon-unchecked");

    const tagColor = ( tagValue.color ? {"color":'#'+tagValue.color} : {} );
    const tagTitle = [ `${tagValue.amount}`,
                       _I_("ViewInventoryTagCloud.tagTitle.itemsOf"),
                       `${tagValue.classes}`,
                       _I_("ViewInventoryTagCloud.tagTitle.varietiesMarkedAs"),
                       `'${tagValue.name}'` ].join(" ");
    return (
      <div  className="view-inventory-tag-entry"
            key={tagValue.internal_name}
            onClick={() => this.toggleTag( tagValue )}
            title={tagTitle}
        >
          <i className={checkedClassName} />&nbsp;
          <div className="view-inventory-tag-entry-name" style={tagColor}>{  tagValue.name  }</div>
          <div className="view-inventory-tag-entry-amount">({  tagValue.amount  }:{  tagValue.classes  })</div>
      </div>);
  }


  renderTagCategory( category )  {
    let items = category.getSorted();
    if ( ! items.length )
      return;

    return (<div  className="view-inventory-tag-category" key={category.category} >
              <div className="view-inventory-tag-category-name">{  category.category_name  }</div>
              { items.map( (tagValue) => this.renderTagValue( tagValue ) ) }
            </div>);
  }


  render()  {
    let cats = this.state.tagCloud.getSorted();
    if ( ! cats.length )
      return null;

    const classes = classMixer("view-inventory-tag-cloud", this.props.hidden && "hidden");

    return (
      <div  className={classes}>
        { cats.map( (category) =>  this.renderTagCategory( category ) ) }
      </div>
    );
  }
}


function updateBlocked(stackedItems)  {
  const clean = stackedItems.map(
      ({appid, classInfo})  =>  ({appId:appid,
                                  marketName:classInfo.market_hash_name,
                                  marketable:classInfo.marketable})
    ).filter(
      it => (!!+it.appId) && (!!it.marketName) && (!!it.marketable)
    );

  const uniqPairs = Object.values(  mkHashMap(  blockedPairsKey, clean  )  );

  uniqPairs.forEach(
      ({appId, marketName})  =>  refreshBlockedPairs(appId, marketName)
    );
}


export class ViewUserInventory extends React.Component  {
  constructor(props)  {
    super(props);

    this.state = {
      apps: {},
      activeApp: null
    };

    this.updateContexts = this.updateContexts.bind(this);
  }


  updateContexts({ appid, contexts, stackedItems,  amount })  {
    this.setState( (prevState, props) =>  {
      const apps = Object.assign({}, prevState.apps);
      if ( amount > 0 )
        apps[appid] = {  contexts,  appid,  amount,  stackedItems  };
      else
        delete apps[appid];

      updateBlocked(stackedItems);

      let activeApp = prevState.activeApp;
      if ( !(activeApp in apps ) )  {
        const appIds = Object.keys( apps );
        activeApp =  ( appIds.length ) ? appIds[0] : null;
      }

      return { apps, activeApp };
    } );
  }


  componentDidMount()  {
    ApplicationEvents.on("market.inventoryUpdated", this.updateContexts );
  }


  componentWillUnmount()  {
    ApplicationEvents.off("market.inventoryUpdated", this.updateContexts );
  }


  render()  {
    const apps = Object.values( this.state.apps );
    if ( apps.length == 0 )
    return (
      <div className="well text-center">
        <div className="empty-inventory-warning">
          <IconFontAwesome type="hand-spock-o" />
          <br />
          {_I_("ViewUserInventory.common.emptyInventory")}
        </div>
      </div>
    );

    return (
      <div>
        <ul className="nav nav-tabs" role="tablist">
        {
          apps.map( (app) =>  {
            const appid = app.appid;
            const active = classMixer( (this.state.activeApp == appid) && "active" );

            return (
              <li key={appid} role="button" className={active}>
                <a role="tab" onClick={ () =>  this.setState({ "activeApp":appid })}>
                  <ViewAppIdIcon appId={appid} compact>
                    <div><span className="tab-amount-pad"><i>{app.amount}</i></span></div>
                  </ViewAppIdIcon>
                </a>
              </li>
            );
          })
        }
        </ul>

        <div className="tab-content">
        {
          apps.map( (app) =>  {
            const appid = app.appid;
            const active = classMixer("tab-pane", (this.state.activeApp == appid) && "active");
            return (
              <div key={appid} role="tabpanel" className={active}>
                <ViewUserGameContents
                                    key={appid}
                                    appid={appid}
                                    gameContexts={app.contexts}
                                    stackedItems={app.stackedItems}
                                />
              </div>
            )
          })
        }
        </div>
      </div>
    );
  }
}


class ViewUserGameContents extends React.Component  {
  constructor(props)  {
    super(props);

    this.state = {
      tagFilter:   (() => true),
      textFilter:  (() => true),
      previewItem: null
    };
  }


  filterFn( item )  {
    if ( !this.state.tagFilter(item) )
      return false;

    if ( !this.state.textFilter(item) )
      return false;

    return true;
  }


  selectItem( item )  {
    this.setState({ previewItem: item });
  }


  render()  {
    const {  gameContexts, appid, stackedItems  }  = this.props;
    const {  previewItem  } = this.state;

    const pairKey = (previewItem && previewItem.classInfo.marketable && previewItem.classInfo.market_hash_name) ?
                        blockedPairsKey({appId:previewItem.appid, marketName:previewItem.classInfo.market_hash_name}) :
                        "";

    return (
        <div className="inventory-container">
          <PaginatedContextView
                stackedItems={stackedItems}
                pageSize={25}
                filterFn={ (item) => this.filterFn(item) }
                onSelectItem={(item) => this.selectItem( item )}
                selectedItem={previewItem}
              />

            <SourceListener blockedPairs={blockedPairsSource}>{
              ({blockedPairs})  =>  {
                  const blockedAfter = getBlockedPairAffectAfter(blockedPairs[pairKey]);
                  return (
                      <ViewItemPreviewSidePane
                          previewItem={previewItem}
                          blockedAfter={blockedAfter}
                          onChangeTextFilter={ ( textFilter ) => this.setState({ "textFilter": textFilter })}
                          gameContexts={gameContexts}
                          appid={appid}
                          onChangeTagFilter={ ( tagFilter ) => this.setState({ "tagFilter": tagFilter })}
                          clearSelected={() => this.selectItem(null)}
                        />
                    );
                }
            }</SourceListener>
        </div>
    );
  }
}





class PaginatedContextView extends React.Component  {
  constructor(props)  {
    super(props);

    this.state = { "pageShift": 0 };
    this.stubClassInfo = {};

  }


  render()  {
    const items = this.props.stackedItems.filter(
        this.props.filterFn
      ).sort(
        PaginatedContextView.sortByClassName
      );

    const pageSize = this.props.pageSize || 1024;
    const pageShift = (this.state.pageShift < items.length) ? this.state.pageShift : 0;
    const pageItems = items.slice( pageShift, pageShift+pageSize );
    if ( pageItems.length < pageSize )  {
      const fillFrom = pageItems.length;
      pageItems.length = pageSize;
      pageItems.fill( null, fillFrom );
    }

    const selectedItem = this.props.selectedItem;

    return (
      <div className="PaginatedContextView">
        <div  className="view-user-items-list">
          {
            pageItems.map((item, idx)=>  {
              let highlight = "view-item-backdrop";
              if ( !item )
                highlight += " disabled";
              else if (item == selectedItem)
               highlight += " active";

              return (
                <div key={idx} className={highlight} >
                  <ViewItemIconic
                            classInfo={item ? item.classInfo : this.stubClassInfo }
                            onClick={() => this.props.onSelectItem( item )}
                      >
                    <ViewAmountBadge amount={item ? item.totalAmount : 0} />
                  </ViewItemIconic>
                </div>
              );
            })
          }
        </div>

        <PagerControl
              pageShift={pageShift}
              setPageShift={(ps) =>  this.setState({ "pageShift":ps })}
              pageSize={pageSize}
              itemsCount={items.length}
            />
      </div>
    );
  }


  static sortByClassName(a,b)  {
    if (a.classInfo.name < b.classInfo.name)  return -1;
    if (a.classInfo.name > b.classInfo.name)  return 1;
    return 0;
  }
}


class ViewItemPreviewSidePane extends React.Component  {
  constructor(props)  {
    super(props);

    const creds  =  SettingsInjections.getCredentials() || {};
    const limitedAccount = (creds.need2step && (!creds.have2step)) ||
                           (creds.needEmailVerification && (!creds.haveEmailVerification));

    this.state =  {  limitedAccount,  };

    this.onClickTrade = () =>  this.tradeItem();
    this.onClickQuickSell = () =>  this.quickSell();

    this.QUICKSELL_DISABLED = true;
  }


  tradeItem()  {
    const item = this.props.previewItem;
    LogStream("VIEWUSERINVENTORY").info( `tradeItem(${item.appid}, ${item.classInfo.market_hash_name}) `);
    ApplicationEvents.emit_async( "market.setCurrentAssetByHash", item.appid, item.classInfo.market_hash_name );
  }

  onClickAuction() {
    window.location.href = 'https://trade.gaijin.net/';
  }


  quickSell()  {
    if ( this.QUICKSELL_DISABLED || this.state.limitedAccount )
      return;

    if ( !this.isRealSellAllowed()  )
      return;

    const item = this.props.previewItem;

    LogStream("VIEWUSERINVENTORY").info( `quickSell(${item.appid}, ${item.classInfo.market_hash_name}) `);
    const asssid  =  item.instances[0].id;
    ViewQuickSellDialog.spawnQuickSellModal(  item.appid,  item.ctxid,  asssid,
                                              item.classInfo.market_hash_name, item.classInfo );
  }


  isRealSellAllowed()  {
    const {  previewItem,  blockedAfter  } = this.props;

    return (
        ( !isPairBlocked(blockedAfter) ) &&
        ( previewItem.classInfo.marketable )  &&
        ( previewItem.instances ) &&
        ( previewItem.instances.length > 0) &&
        ( previewItem.totalAmount > 0 )
      );
  }


  renderButtons()  {
    const {  previewItem:{  classInfo  },  blockedAfter  } = this.props;
    if ( classInfo.auctionable )
      return (
        <div className="inventory-item-preview-footer">
          <BootButton  variant="success"  onClick={this.onClickAuction}  >
            <IconImage image="auction_edit.svg"/>&nbsp;
            {_I_("ViewItemPreviewSidePane.ViewButton.label.auctions")}
          </BootButton>
        </div>
      );

    const viewOnly = isExpired(classInfo) ||
                     this.state.limitedAccount ||
                     isPairBlocked(blockedAfter);

    const canQSell = (!viewOnly) &&
                     (!this.state.limitedAccount) &&
                     this.isRealSellAllowed() &&
                     (!this.QUICKSELL_DISABLED);

    return (
      <div className="inventory-item-preview-footer">
        <BootButton  variant="success"  onClick={this.onClickTrade}  >
            <IconGlyphicon type="shopping-cart"/>&nbsp;
            {_I_( viewOnly?
                "ViewItemPreviewSidePane.ViewButton.label"  :
                "ViewItemPreviewSidePane.TradeButton.label"  )}
        </BootButton>

        {!!canQSell &&
          <BootButton  variant="warning"  onClick={this.onClickQuickSell} >
              <IconGlyphicon type="piggy-bank"/>&nbsp;
              {_I_("ViewItemPreviewSidePane.QuickSellButton.label")}
          </BootButton>}
      </div>);
  }


  renderItemPreview()  {
    const {  previewItem,  blockedAfter  } = this.props;
    if ( !previewItem )
      return;

    return [
          (<BootButton  variant="primary" size="xsmall"  block key="Unselect"
                        onClick={this.props.clearSelected} >
              <IconFontAwesome type="reply"/>&nbsp;
              {_I_("ViewItemPreviewSidePane.UnselectButton.label")}
          </BootButton>),
          (<ViewItemDetailed  key={previewItem.classid}
                  classInfo={previewItem.classInfo}
                  amount={previewItem.totalAmount}
                  appId={previewItem.appid}
                  blockedAfter={blockedAfter}
                >

              {  this.renderButtons()  }
          </ViewItemDetailed>)
      ];
  }


  render()  {
    return (
        <div className="inventory-item-preview" >
            { this.renderItemPreview() }
            <ViewInventoryTextFilter  onChangeFilter={this.props.onChangeTextFilter}
                                      hidden={!!this.props.previewItem} />
            <ViewInventoryTagCloud    appid={this.props.appid}
                                      gameContexts={this.props.gameContexts}
                                      onChangeFilter={this.props.onChangeTagFilter}
                                      hidden={!!this.props.previewItem}  />
        </div>
      );
  }
};


defineSimpleTerm( "ViewUserInventory.common.emptyInventory",  "At the moment your inventory is empty",       {
  "ru_RU": "Инвентарь пока пуст",
  "cs_CZ": "At the moment your inventory is empty",
  "fr_FR": "A cet instant, votre inventaire est vide",
  "de_DE": "Im Moment ist dein Inventar leer",
  "it_IT": "Al momento il tuo inventario è vuoto",
  "ko_KR": "인벤토리가 비어있습니다",
  "pl_PL": "W tym momencie inwentarz jest pusty",
  "pt_PT": "At the moment your inventory is empty",
  "es_ES": "En este momento tu inventario está vacío",
  "zh_CN": "目前你的库存为空",
  "zh_TW": "目前你的庫存為空"
} );


defineSimpleTerm( "ViewItemPreviewSidePane.UnselectButton.label",  "Filters",       {
  "ru_RU": "Фильтры",
  "cs_CZ": "Filters",
  "fr_FR": "Filtres",
  "de_DE": "Filter",
  "it_IT": "Filtri",
  "ko_KR": "필터로 돌아가기",
  "pl_PL": "Filtry",
  "pt_PT": "Filters",
  "es_ES": "Filtros",
  "zh_CN": "筛选条件",
  "zh_TW": "篩選條件"
} );


defineSimpleTerm( "ViewItemPreviewSidePane.TradeButton.label",  "Sell/Buy",       {
  "ru_RU": "Продать/Купить",
  "cs_CZ": "Sell/Buy",
  "fr_FR": "Vendre / acheter",
  "de_DE": "Verkaufen/Kaufen",
  "it_IT": "Compra/Vendi",
  "ko_KR": "구매/판매",
  "pl_PL": "Sprzedaj/Kup",
  "pt_PT": "Sell/Buy",
  "es_ES": "Vender/Comprar",
  "zh_CN": "出售/购买",
  "zh_TW": "出售/購買"
} );


defineSimpleTerm( "ViewItemPreviewSidePane.ViewButton.label",  "View",       {
  "ru_RU": "Подробнее",
  "cs_CZ": "View",
  "fr_FR": "Vue",
  "de_DE": "Ansicht",
  "it_IT": "Vedi",
  "ko_KR": "확인하기",
  "pl_PL": "Widok",
  "pt_PT": "View",
  "es_ES": "Ver",
  "zh_CN": "查看",
  "zh_TW": "查看"
} );


defineSimpleTerm( "ViewItemPreviewSidePane.ViewButton.label.auctions",  "Put up for auction",       {
  "ru_RU": "Выставить на аукцион",
  "cs_CZ": "Vystavit do aukce",
  "fr_FR": "Mettre aux enchères",
  "de_DE": "Zur Auktion stellen",
  "it_IT": "Mettere all'asta",
  "ko_KR": "경매에 내놓다",
  "pl_PL": "Wystawić na aukcję",
  "pt_PT": "Colocar em leilão",
  "es_ES": "Poner en subasta",
  "zh_CN": "拍卖",
  "zh_TW": "拍賣"
} );


defineSimpleTerm( "ViewItemPreviewSidePane.QuickSellButton.label",  "Quick sell",       {
  "ru_RU": "Продать",
  "cs_CZ": "Quick sell",
  "fr_FR": "Vente rapide",
  "de_DE": "Schnellverkauf",
  "it_IT": "Vendita rapida",
  "ko_KR": "빠른 판매",
  "pl_PL": "Szybka sprzedaż",
  "pt_PT": "Quick sell",
  "es_ES": "Venta rápida",
  "zh_CN": "快速出售",
  "zh_TW": "快速出售"
} );


defineSimpleTerm( "ViewInventoryTagCloud.tagTitle.itemsOf",  "items of",       {
  "ru_RU": "предмета(ов)",
  "cs_CZ": "items of",
  "fr_FR": "éléments de",
  "de_DE": "Items von",
  "it_IT": "oggetti per",
  "ko_KR": "다음 게임의 아이템",
  "pl_PL": "przedmioty z",
  "pt_PT": "items of",
  "es_ES": "artículos de",
  "zh_CN": "件物品，种数为",
  "zh_TW": "件物品，總數為"
} );


defineSimpleTerm( "ViewInventoryTagCloud.tagTitle.varietiesMarkedAs",  "varieties marked as",       {
  "ru_RU": "разновидности(ей), отмеченых как",
  "cs_CZ": "varieties marked as",
  "fr_FR": "variétés marquées comme",
  "de_DE": "Sorten vermerkt als",
  "it_IT": "tipi contrassegnati come",
  "ko_KR": "다음 태그를 만족하는 품목",
  "pl_PL": "odmiany oznaczone jako",
  "pt_PT": "varieties marked as",
  "es_ES": "variedades marcadas como",
  "zh_CN": "多个标记为",
  "zh_TW": "多個標記為"
} );

